import { RestrictedAreasModelBase } from './restricted-areas-model';
import { ZoneFeature, Zones } from './zones-base-interfaces';

export class RestrictedAreasModelImpl extends RestrictedAreasModelBase {
    async getRestrictedAreas(): Promise<ZoneFeature[] | null> {
        await this._loadingPromise;

        const areas = this._areas!.features.filter(z => z.properties.type === "No-Go");
        return areas;
    }

    constructor(geojson?: Zones) {
        super();

        if (geojson) {
            this._areas = geojson;
        } else {
            this._loadingPromise = this._loadGeoJson();
            setInterval(() => this._loadGeoJson(), 60*60*1000); // refresh the list every 1h
        }
    }

    private _areas: Zones | null = null;
    private _loadingPromise: Promise<void> | null = null;

    private async _loadGeoJson() {
        const areas : Zones = (await (await fetch("./restricted_areas.geojson")).json());
        if (areas) {
            this._areas = areas;
        }
    }
}
